// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toast {
  visibility: hidden;
  z-index: 1;

  background: #800000;
  color: #FFFFFF;
  font-size: 1.1rem;
  font: sans-serif;

  padding: 10px 20px;

  transition: visibility 200ms, opacity 200ms ease-out;

  position: fixed;
  left: 50%;
  bottom: 5vh;
  transform: translate(-50%, 0);
  opacity: 0%;
}

#toast.show {
  transition: visibility 200ms, opacity 200ms ease-out;

  visibility: visible;
  opacity: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/style/toast.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;;EAEV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;;EAEhB,kBAAkB;;EAElB,oDAAoD;;EAEpD,eAAe;EACf,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,oDAAoD;;EAEpD,mBAAmB;EACnB,aAAa;AACf","sourcesContent":["#toast {\n  visibility: hidden;\n  z-index: 1;\n\n  background: #800000;\n  color: #FFFFFF;\n  font-size: 1.1rem;\n  font: sans-serif;\n\n  padding: 10px 20px;\n\n  transition: visibility 200ms, opacity 200ms ease-out;\n\n  position: fixed;\n  left: 50%;\n  bottom: 5vh;\n  transform: translate(-50%, 0);\n  opacity: 0%;\n}\n\n#toast.show {\n  transition: visibility 200ms, opacity 200ms ease-out;\n\n  visibility: visible;\n  opacity: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
